import {
  EMPLOYEEPROFILE_FETCHING,
  EMPLOYEEPROFILE_FAILED,
  EMPLOYEEPROFILE_SUCCESS,
} from "../actions/types";

const initialState = {
  result: null,
  isFetching: false,
  isError: false,
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case EMPLOYEEPROFILE_FETCHING:
      return { ...state, result: null, isFetching: true, isError: false };
    case EMPLOYEEPROFILE_FAILED:
      return { ...state, result: null, isFetching: false, isError: true };
    case EMPLOYEEPROFILE_SUCCESS:
      return { ...state, result: payload, isFetching: false, isError: false };
    default:
      return state;
  }
}
